<template>
	<section>
        <div class="margin-bottom-10">
            <vButton style="position:absolute;right:10px" theme="default" @click="cancel">返回</vButton>
        </div>
		<compWrapper title="基本信息" theme="primary">
			<compFormQuery class="margin-layout" :formdata="getBase" :value="formData" placeholder="--"></compFormQuery>
		</compWrapper>
		<compWrapper title="产品信息" theme="primary">
			<vTableSimple class="margin-layout" :data="productList" :columns="getCusproductColumns"></vTableSimple>
		</compWrapper>
		<compLog wrapper :data="logList"></compLog>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { HttpClaimOrderDetail } from '@/service/salesreturns';
import mixin from "../mixin";
import { mapGetters } from 'vuex';

export default {
	mixins: [mixin],
    props:['activeids'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading: false,
			id: this.$route.query.id || this.activeids,
			formData: { saleReturnPlanStatus: 0 },
			productList: [],
			logList: [],
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList','getUserManageWarehouseList', 'getBillcusWareList']),
		getBase() {
			return [{
				label: "认领处理单号",
				key: "claimNo",
			},
            {
				label: "状态",
				key: "status",
				options: this.getClaimOrderHandleOrderStatus,
			},
            {
				label: "认领单号",
				key: "claimPlanNo",
			},
            {
				label: "来源单号",
				key: "sourceNo",
			},
			{
				label: "仓库",
				key: "warehosueName",
			},
			{
				label: "项目",
				key: "lineName",
			},
			{
				label: "备注",
				key: "remark",
			}];
		},
		getCusproductColumns() {
            return[
                {
                    title: 'No',
                    type: 'index',
                    width: 60
                },
                {
                    title: 'SKU',
                    key: 'sku'
                },
                {
                    title: '建议处理方式',
                    render:(h,{row})=>{
                        return <div>{ this.findRenderLabel(this.getHandleType, row.goodsReturnType)|| '--' }</div>
                    }
                },
                {
                    title: '备注',
                    key: 'remark'
                },
                {
                    title: '库存类型',
                    key: 'inventoryType',
                    render: ( h, { row })=>{
                        return row.inventoryType === 0 ? '可售' : row.inventoryType === 1 ? '不可售' : '--'
                    }
                },
                {
                    title: '处理数量',
                    key: 'qty'
                },
            ]
		},
    },
	methods: {
		//获取计划单详情
		getDetail() {
			this.loading = true;
			HttpClaimOrderDetail({ id: this.id }).then(res => {
				const data = res.data || {};
				this.formData = data.claimOrderEntity;
				this.productList = data.claimOrderItemEntities;
				this.logList = data.opLogEntityList;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
		cancel() {
			this.$router.push({
				name: 'salesHandleOrder'
			})
		}
	}
};
</script>
